<script>
import {tabs, finishedLabel} from './archetype'
export default {
    name: 'AlimentosTabs',
    data: () => {
        return {
            tabs
        }
    },
    props: {
        value: {
            type: String,
            default: tabs[0]
        },
        currentEstatus: {
            type: String
        }
    },
    methods: {
        tabAlias(tabName){
            let matrix = {
                'Finalizada': 'Sumario de preparación'
            }
            return (matrix[tabName]) ? matrix[tabName] : tabName;
        },
        isDisabled(indexItem) {
            if(!this.currentEstatus) {
                if(indexItem == 0){
                    return false;
                } else {
                    return true;
                }
            }
            else {
                return (indexItem  > tabs.indexOf(this.currentEstatus))
            }
        },
        async askForChangingTo(tab){
            try {
                this.$emit('input', tab)
            } catch(e){
                console.error8e
            }
        }
    },
    beforeMount(){
        if(!this.value){
            this.$emit('input', tabs[0])
        }
    }
}
</script>

<template>
    <b-nav id="AlimentosTabs" tabs>
        <b-nav-item v-for="(tab, $index) in tabs" :key="tab" 
            :active="value == tab" 
            :disabled="isDisabled($index)" 
            @click="askForChangingTo(tab)"
            variant="primary">
            {{tabAlias(tab)}} 
        </b-nav-item>
    </b-nav>
</template>

<style lang="less">
    #AlimentosTabs {
        a {
            &:not(.disabled){
                color: var(--primary);
            }
            &.disabled {
                opacity: 0.4;
            }
        }
    }
</style>